<template>
  <div
    v-text="error"
    class="bg-red-50 px-4 py-2 my-4 text-red-700 border border-red-300 rounded-lg"
  ></div>
</template>
<script>
export default {
  props: ["error"],
  data() {
    return {};
  },
};
</script>